// ┌─────────────────────────────────────────────────────────────────────────┐
// │ Programes de transformació — càrrega dinàmica des de Sherpa.              │
// └─────────────────────────────────────────────────────────────────────────┘
//
// Parla el patró RPC REAL de Sherpa (com `vue-dashboard/src/services/dashboardService.js`):
//   POST {baseURL}/{ts}/{area}/{bloc}/{op}  amb cos { requestHeader, requestContent }
// NO el dialecte REST fictici de `definitionApi.js` (/forms…), que no existeix al backend.
//
// Endpoint: /filetransform/aliasprogram/task → FileTransformProcess.doTaskAliasprogram.
// Rep un array d'àlies (els camps del formulari) i torna els programes ACTIUS assignats
// a algun d'ells: [{ id, name, description, aliases:[…], code }]. Sense àlies → tots.
import sherpaClient from './sherpaClient.js';
import { getRuntimeConfig, effectiveBaseUrl } from '@vft/config/runtimeConfig.js';

function getHost() {
  try {
    return new URL(effectiveBaseUrl(getRuntimeConfig())).origin;
  } catch {
    return '';
  }
}

// Capçalera estàndard de Sherpa (mateixa forma que dashboardService.buildHeader).
function buildHeader(refererPath = '/file-transform/file-transform-management/search-transform-program') {
  const host = getHost();
  const cfg = getRuntimeConfig();
  const lang = (cfg.lang || 'ca_ES').toLowerCase();
  return {
    acceptLanguage: 'ca-ES',
    externalReferer: `${host}/login`,
    lang,
    referer: `${host}${refererPath}`,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    product: 'Gecko',
    platform: 'Win32',
    vendor: 'Google Inc.',
    token: null,
    version: null,
  };
}

// Torna els programes de transformació assignats a algun dels `aliases` donats.
// `aliases`: ids de camp del formulari carregat (els decideix el formulari, no el component).
export async function fetchProgramsByAliases(aliases = []) {
  const ts = Date.now();
  const payload = {
    requestHeader: buildHeader(),
    requestContent: { jsonData: Array.isArray(aliases) ? aliases : [] },
  };
  const { data } = await sherpaClient.post(`${ts}/filetransform/aliasprogram/task`, payload);
  return Array.isArray(data) ? data : [];
}

// Torna els programes GENÈRICS (type='correction') actius, ordenats per exec_order.
// Són els del pas 6 (Correcció): s'apliquen a tots els camps, sense àlies. No rep
// paràmetres (el backend ja filtra per tipus).
export async function fetchCorrectionPrograms() {
  const ts = Date.now();
  const payload = {
    requestHeader: buildHeader(),
    requestContent: { jsonData: [] },
  };
  const { data } = await sherpaClient.post(`${ts}/filetransform/correctionprogram/task`, payload);
  return Array.isArray(data) ? data : [];
}
